import React, {useRef, useEffect} from 'react'
import PageApp from '../../../Page';
import ModalEdit from './Add'
import EstadoCuentaModal from './EstadoCuentaModal';
import { HomeOutlined, UnorderedListOutlined, ClockCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Table, Empty, Modal, Divider, Button, message, Space, Select} from 'antd';
import { getEmpleados } from '../../../../apis/OdooApi';
import { getList as getAllTiposSaldo } from '../../../../apis/TipoSaldoApi';
import {getAll, drop} from '../../../../apis/CreditoInfonavitApi';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [  {
    href: '',
    title: <>
      <HomeOutlined />
      <span>Inicio</span>
    </>,
  },
  {
    href: '',
    title: (
      <>
        <UnorderedListOutlined />
        <span>Recursos Humanos</span>
      </>
    ),
  },
  {
    href: '',
    title: (
      <>
        <ClockCircleFilled />
        <span>Crédito Infonavit</span>
      </>
    ),
}];

const CreditoInfonavitPage = () => {
    const [empleados, setEmpleados] = React.useState([]);
    const [tiposSaldo, setTiposSaldo] = React.useState([]);
  const [filtroSuspension, setFiltroSuspension] = React.useState('activos');

    const loadCatalogs = async () => {
      try {
        const [resEmpleados, resTiposSaldo] = await Promise.all([
          getEmpleados(),
          getAllTiposSaldo()
        ]);

        if (resEmpleados.ok) setEmpleados(resEmpleados.payload);
        if (resTiposSaldo.ok) setTiposSaldo(resTiposSaldo.payload);
      } catch (err) {
        console.error("Error cargando catálogos:", err);
      }
    };
    const getEmpleadoNombre = (id) => {
      const emp = empleados.find(e => e.value === id);
      return emp ? emp.text : `ID ${id}`;
    };

    const getTipoSaldoNombre = (id) => {
      const ts = tiposSaldo.find(t => String(t.value) === String(id));
      return ts ? ts.displayTitle : `ID ${id}`;
    };

    const getTipoCreditoNombre = (id) => {
      const mapa = {
        0: "Ninguno",
        1: "Porcentaje",
        2: "Cuota",
        3: "Veces SM"
      };
      return mapa[id] || "Desconocido";
    };
    const [items, setItems] = React.useState([]);
    const [openEdit, setOpenEdit] = React.useState(false);
    const [periodSelected, setPeriodSelected] = React.useState(null);

    const filteredItems = React.useMemo(() => {
      if (filtroSuspension === 'suspendidos') {
        return items.filter((item) => !!item.fecha_suspension);
      }
      if (filtroSuspension === 'todos') {
        return items;
      }
      return items.filter((item) => !item.fecha_suspension);
    }, [items, filtroSuspension]);

    const columns = [
      {
        title: 'Empleado',
        dataIndex: 'empleado_id',
        key: 'empleado',
        render: (value) => getEmpleadoNombre(value),
      },
      {
        title: 'Tipo de Saldo',
        dataIndex: 'tipo_saldo',
        key: 'tipo_saldo',
        render: (value) => getTipoSaldoNombre(value),
      },
      {
        title: 'Tipo de Crédito',
        dataIndex: 'tipo_credito',
        key: 'tipo_credito',
        render: (value) => getTipoCreditoNombre(value),
      },
      {
        title: 'Fecha Inicio',
        dataIndex: 'fecha_inicio',
        key: 'fecha_inicio',
      },
      {
        title: 'Fecha Suspensión',
        dataIndex: 'fecha_suspension',
        key: 'fecha_suspension',
      },
      {
        title: 'Monto Inicial',
        dataIndex: 'monto_inicial',
        key: 'monto_inicial',
      },
      {
        title: 'Numero de Crédito',
        dataIndex: 'numero_credito',
        key: 'numero_credito',
      },
      {
        title: 'Saldo',
        dataIndex: 'saldo',
        key: 'saldo',
      },
      {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        render: (item, object)=> {
          return <Space>
          <EstadoCuentaModal credito={object} empleadoNombre={getEmpleadoNombre(object.empleado_id)} />
          <Button type='primary' size='small' onClick={()=>{
              openDetails(object);
          }}>Editar</Button>
          <Button type='primary' size='small' danger onClick={()=>{
              deleteConfirm(object);
          }}>Baja</Button>
        </Space>
        }
      }
    ];

    const openDetails = async (object)=>{
      setOpenEdit(true);
      setPeriodSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el registro?',
            icon: <ExclamationCircleFilled />,
            content: 'Si el registro tiene detalles asociados, no podrá eliminarse, No podrás recuperar su información.',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id)=>{
        const response = await drop(id);
        if(response.ok){
            message.success('El registro ha sido eliminado!');
        }
        await refreshData();
    }

    const btnClick = ()=>{
      setOpenEdit(true);
      setPeriodSelected(null);
    }

    const onHandlerFinish = async (refresh,  avoidClose) => {
      if(!avoidClose){
        setOpenEdit(false);
      }

      if(refresh){
        await refreshData();
      }
    }

    const refreshData = async ()=> {
      const response = await getAll();
      if(response.ok){
        let items = response.payload;
        setItems(items);
      }
    }

    const effectRan = useRef(false);
    useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await loadCatalogs();
          await refreshData();
        })();
      }
    
      return () => effectRan.current = true;
    }, []);
    
    
    return <PageApp routes={routes}>
      <Space>
        <Button type="primary" onClick={btnClick}>
            Agregar
        </Button>
        <Select
          value={filtroSuspension}
          onChange={setFiltroSuspension}
          style={{ minWidth: 210 }}
          options={[
            { value: 'activos', label: 'Activos' },
            { value: 'suspendidos', label: 'Suspendidos' },
            { value: 'todos', label: 'Todos' },
          ]}
        />
      </Space>
      <Divider/>
      {
          filteredItems.length == 0 ? <Empty />:
          <Table dataSource={filteredItems} columns={columns} />
      }
      {
        (openEdit && periodSelected && periodSelected.id > 0) &&
        <ModalEdit title={"Editar"} id={periodSelected.id} open={openEdit} finish={onHandlerFinish}/>
      }
      {
        (openEdit && !periodSelected) &&
        <ModalEdit title={"Crear"} open={openEdit} finish={onHandlerFinish}/>
      }
    </PageApp>
}   

export default CreditoInfonavitPage;
